import React, { useState, useEffect } from 'react';
import styles from './EventRegistrationHeader.module.css';

const EventRegistrationHeader = ({ title, dateRange, timeRange, imageUrl }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = imageUrl;
    image.onload = () => setImageLoaded(true);
  }, [imageUrl]); // imageUrl is now a dependency

  return (
    <header className={styles.eventHeader}>
      {imageLoaded ? (
        <img
          className={styles.eventImage}
          src={imageUrl}
          alt={`${title} event image`}
          loading="lazy"
        />
      ) : (
        <div className={styles.placeholder}></div>
      )}
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.dateTime}>
        <span className="fa fa-calendar" aria-hidden="true"></span>
        <span className={styles.accessibleText}>Date:</span> {dateRange}
      </p>
      <p className={styles.dateTime}>
        <span className="fa fa-clock" aria-hidden="true"></span>
        <span className={styles.accessibleText}>Time:</span> {timeRange}
      </p>
    </header>
  );
};

export default EventRegistrationHeader;

